import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPaypalComponent } from './simple-icons-paypal.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPaypalComponent ],
    exports:      [ SimpleIconsPaypalComponent ],
    bootstrap:    []
})
export class SimpleIconsPaypalModule {}
